import './DeletePostingConfirmModal.scss';

interface DeletePostingConfirmModalProps {
  applicantCount: number;
  onClose: () => void;
  onConfirmClosePosting: () => void;
  onConfirmDeletePosting: () => void;
  submitting?: boolean;
}

export default function DeletePostingConfirmModal({
  applicantCount,
  onClose,
  onConfirmClosePosting,
  onConfirmDeletePosting,
  submitting = false,
}: DeletePostingConfirmModalProps) {
  return (
    <div className="delete-posting-modal-overlay" onClick={onClose}>
      <div className="delete-posting-modal" onClick={(e) => e.stopPropagation()}>
        <div className="delete-posting-modal__header">
          <div className="delete-posting-modal__title">공고를 삭제하시겠습니까?</div>
          <button type="button" className="delete-posting-modal__close" onClick={onClose} aria-label="닫기">
            ×
          </button>
        </div>

        <div className="delete-posting-modal__body">
          <p>
            이미 입사 지원자가 {applicantCount}명 있습니다. 공고를 삭제하면 지원자 목록 조회가
            불가능해집니다. 마감 처리하시겠습니까, 아니면 공고 삭제를 진행하시겠습니까?
          </p>
        </div>

        <div className="delete-posting-modal__footer">
          <button
            type="button"
            className="delete-posting-modal__btn delete-posting-modal__btn--secondary"
            onClick={onClose}
            disabled={submitting}
          >
            취소
          </button>
          <button
            type="button"
            className="delete-posting-modal__btn delete-posting-modal__btn--close"
            onClick={onConfirmClosePosting}
            disabled={submitting}
          >
            마감 처리
          </button>
          <button
            type="button"
            className="delete-posting-modal__btn delete-posting-modal__btn--danger"
            onClick={onConfirmDeletePosting}
            disabled={submitting}
          >
            공고 삭제
          </button>
        </div>
      </div>
    </div>
  );
}
